import React, { useContext } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import "../sass/PickLocation.scss";
import { CityContext } from "./context/CityContext";
import { LayerContext } from "./context/LayerContext";
import { SelectedDataSet } from "./context/SelectedDataset";
import Input from "./Input";
import Popup from "./Popup";

const PickLocation = ({ locData, setPickLoc }) => {
  const { getLayer } = useContext(LayerContext);
  const { getSelectedIdx } = useContext(SelectedDataSet);
  const { getSelectedDataSet } = useContext(SelectedDataSet);
  const {getCity}=useContext(CityContext)
  return (
    <Popup setPickLoc={setPickLoc}>
      <main>
        <div>
          <h2>Pick a location</h2>
        </div>
        <div>
          <ul className="locList">
            {locData.map((data, ie) => {
              return (
                <li>
                  <Link
                    className="cityname"
                    key={ie}
                    to={"/" + data.locationURL + "/agriculture"}
                    onClick={() => {
                      getCity(data.locationURL)
                      setPickLoc(false);
                      getLayer(false);
                      getSelectedIdx([]);
                      getSelectedDataSet();
                    }}
                  >
                    {data.location}
                  </Link>
                </li>
              );
            })}
          </ul>
          <div className="popupFooter">
            <span></span>
            <div
              className="btn"
              onClick={() => {
                setPickLoc(false);
              }}
            >
              Close
            </div>
          </div>
        </div>
      </main>
    </Popup>
  );
};

export default PickLocation;
